import { createContext, useContext, useState } from "react";
import { useFilter } from "../../../../../hooks/filter";
import { Item } from "../../../../../utils/types/generals";
import { getArea, getDepartments } from "../../../../../utils/methods/geServiceWithItemsFormat";
import { useInput } from "../utils/hooks/input";
import { validateItemsMain } from "../utils/formater";
import { InputService, TimeConfigContextState } from "../utils/types";
import { sharederviceFetch } from "../../../../../utils/constants/callService";
import { formatFilterMain } from "../utils/constants";

export const TimeConfigContext = createContext<TimeConfigContextState>(Object({}))

export const useTimeConfigContext = () => useContext(TimeConfigContext)

export function TimeConfigProvider({ children }: { children: JSX.Element }) {
    const [item, setItem] = useState<Record<string, Item[]>>({})
    const inputMain = useInput()
    const filter = useFilter({
        formatFilter: formatFilterMain,
        externalValidation: (payload) => {
            const { localeBody, depatmentList } = validateItemsMain({ ...payload, departmentItem: item.departments })
            if (payload.name === 'areas') {
                inputMain.setInput(prev => ({ ...prev, departments: { ...prev.departments, items: depatmentList } }))
            }
            return localeBody
        }
    })

    const getAreasService = async (payload?: InputService) => {
        if (item.areas?.length) { return }
        const areas = await getArea()
        setItem((prev) => ({ ...prev, areas, }))

    }

    const getDepartmentService = async (payload?: InputService) => {
        if (item.departments?.length) { return item.departments || []}
        const departments = await getDepartments()
        setItem((prev) => ({ ...prev, departments, }))
        return departments || []
    }

    const getCategories = async (payload?: InputService) => {
        if (item.section?.length) { return }
        const { item: serviceItem } = await sharederviceFetch.catalogList()
        setItem((prev) => ({ ...prev, section: serviceItem, }))
    }

    return (
        <TimeConfigContext.Provider value={{
            filter,
            item,
            service: {
                getAreasService,
                getDepartmentService,
                getCategories,
            },
            inputMain,
            setItem,
        }}>
            {children}
        </TimeConfigContext.Provider>
    )
}